import classNames from 'classnames';
import React, {memo} from 'react';

import {useApplicationSettings} from '@/hooks/useApplicationSettings';
import style from '@/layout/TopLayout/index.less';

const Logo = () => {
  const {logo} = useApplicationSettings();

  return (
    <div className={classNames(['flex items-center', style.logoContainer])}>
      <img className={'mr-5 logo'} src={logo} alt="logo"/>
      {/*{searchSection}*/}
    </div>
  );

};

export default memo(Logo);
